import { SUPABASE_FETCH_REQUEST_URL_TAG } from "../http/fetchWithRetryPolicy";

import { SupabaseRequestError } from "./SupabaseRequestError";

/**
 * Strips the `[supabase_request_url:…]` suffix appended by the Supabase global fetch (see `fetchWithRetryPolicy`).
 */
export function parseTaggedSupabaseRequestUrl(message: string): {
  displayMessage: string;
  requestUrl?: string;
} {
  const tag = SUPABASE_FETCH_REQUEST_URL_TAG;
  const idx = message.lastIndexOf(` ${tag}`);
  if (idx === -1) {
    return { displayMessage: message };
  }
  const suffix = message.slice(idx + 1 + tag.length);
  if (!suffix.endsWith("]")) {
    return { displayMessage: message };
  }
  const encoded = suffix.slice(0, -1);
  try {
    return {
      displayMessage: message.slice(0, idx).trimEnd(),
      requestUrl: decodeURIComponent(encoded),
    };
  } catch {
    return { displayMessage: message };
  }
}

function getSupabaseClientErrorMessage(error: unknown): string {
  if (typeof error === "object" && error !== null && "message" in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === "string" && message.length > 0) {
      return message;
    }
  }
  if (typeof error === "string" && error.length > 0) {
    return error;
  }
  return "Supabase request failed";
}

/**
 * If Supabase client or RPC returned an error object, throws {@link SupabaseRequestError} with the original value as `cause`.
 * No-op when `error` is null, undefined, or false.
 */
export function throwOnSupabaseError(error: unknown): void {
  if (error == null || error === false) return;

  const rawMessage = getSupabaseClientErrorMessage(error);
  const { displayMessage, requestUrl } = parseTaggedSupabaseRequestUrl(rawMessage);
  
  throw new SupabaseRequestError(displayMessage, {
    cause: error,
    ...(requestUrl !== undefined && { requestUrl }),
  });
}
